/**
 * wiki-bridge — 把「答錯的題」回流進學生 LLM Wiki(R-001 Karpathy 模式)的共用器。
 *
 * 緣由(boss 2026-06-11「你沒有用 wiki llm 嗎」):原本只有「複習中心批改」
 * (grade-review.ts)會 ingest 進 per-student wiki;拍照上傳考卷、變形練習卷、
 * A4 練習卷批改的錯題都只進錯題本 —— student wiki 漏掉三條主要錯誤流,
 * 複習卷生成(wiki → Claude 生卷)就看不到這些弱點。本模組統一回流。
 *
 * 鐵則:best-effort、fire-and-forget —— 錯題本(本機)永遠先寫好,wiki 同步
 * 失敗不阻斷 UI、不丟資料(下次有新錯題會再帶到)。沒 familyCode(未開同步)
 * 就靜默跳過。純學習側。
 */

import { ingestToWiki, type IngestSource } from '../../shared/wiki-client';
import { deriveQuestionId } from '../../shared/mistake-log';
import type { PlayerProgress, Subject } from '../../shared/types';

export interface WikiMistakeFeed {
  subject: Subject;
  kp: string;
  prompt: string;
  correctAnswer: string | number;
}

/** 把一批答錯題餵進學生 wiki(非同步、吞錯)。回傳是否有發出請求(供測試)。 */
export function feedMistakesToWiki(progress: PlayerProgress, feeds: WikiMistakeFeed[]): boolean {
  if (!progress.familyCode || feeds.length === 0) return false;
  const sources: IngestSource[] = feeds.map((f) => ({
    kind: 'mistake',
    subject: f.subject,
    kp: f.kp,
    questionId: deriveQuestionId(f.prompt),
    prompt: f.prompt,
    correctAnswer: String(f.correctAnswer),
  }));
  void ingestToWiki(progress.familyCode, sources).catch(() => {
    // 吞掉 — 錯題本已在本機,wiki 之後的 ingest 會再補上弱點訊號。
  });
  return true;
}
